export const DEFAULT_TWIN_IMAGE_ID = "cnc-5-axis";

export const TWIN_IMAGES = Object.freeze([
  { id: "solar-demand", label: "Solar, demand and grid", shortLabel: "SOLAR / DEMAND / GRID", src: "/twin-images/twin-solar-demand.png", alt: "Photovoltaic panels, inverter, industrial electricity demand and grid connection represented by the Digital Twin" },
  { id: DEFAULT_TWIN_IMAGE_ID, label: "CNC machine", shortLabel: "5-AXIS CNC REPRESENTATION", src: "/digital-twin-cnc-5-axis-v3.png", alt: "Five-axis CNC machining center represented by the Digital Twin" },
  { id: "generic-system", label: "Generic system", shortLabel: "GENERIC SYSTEM REPRESENTATION", src: "/twin-images/twin-generic-system.png", alt: "Generic modular industrial system represented by the Digital Twin" },
  { id: "robotic-cell", label: "Robotic cell", shortLabel: "ROBOTIC CELL REPRESENTATION", src: "/twin-images/twin-robotic-cell.png", alt: "Industrial robotic production cell represented by the Digital Twin" },
  { id: "energy-system", label: "Energy system", shortLabel: "ENERGY SYSTEM REPRESENTATION", src: "/twin-images/twin-energy-system.png", alt: "Industrial renewable energy system represented by the Digital Twin" },
  { id: "logistics-system", label: "Logistics", shortLabel: "LOGISTICS SYSTEM REPRESENTATION", src: "/twin-images/twin-logistics-system.png", alt: "Automated logistics system represented by the Digital Twin" },
  { id: "process-plant", label: "Process plant", shortLabel: "PROCESS PLANT REPRESENTATION", src: "/twin-images/twin-process-plant.png", alt: "Industrial process plant represented by the Digital Twin" },
]);

const TWIN_IMAGE_BY_ID = new Map(TWIN_IMAGES.map((image) => [image.id, image]));

export function normalizeTwinImageId(value) {
  return TWIN_IMAGE_BY_ID.has(String(value ?? "")) ? String(value) : DEFAULT_TWIN_IMAGE_ID;
}

export function metadataWithTwinImage(value, imageId) {
  if (!TWIN_IMAGE_BY_ID.has(imageId)) throw Object.assign(new Error("Choose an image from the Twin catalog"), { status: 400 });
  let metadata;
  try { metadata = typeof value === 'string' ? JSON.parse(value || '{}') : value ?? {}; }
  catch { throw Object.assign(new Error("Existing Twin metadata is not valid JSON"), { status: 422 }); }
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata) || (metadata.objectid != null && (typeof metadata.objectid !== 'object' || Array.isArray(metadata.objectid)))) {
    throw Object.assign(new Error("Existing Twin metadata must be a JSON object"), { status: 422 });
  }
  return JSON.stringify({ ...metadata, objectid: { ...metadata.objectid, imageId } });
}

export function twinImageFromMetadata(value) {
  let metadata = value;
  try {
    if (typeof metadata === "string") metadata = JSON.parse(metadata || "{}");
  } catch {
    metadata = {};
  }
  const imageId = normalizeTwinImageId(metadata?.objectid?.imageId);
  return TWIN_IMAGE_BY_ID.get(imageId) ?? TWIN_IMAGE_BY_ID.get(DEFAULT_TWIN_IMAGE_ID);
}
